import React from 'react';
import { Spinner } from 'react-bootstrap';

import useVideoList from 'utils/hooks/videos/useVideoList';
import { VideoProduct, VideosGetLast } from 'helper/videos';

import VideoCard from '../VideoCard';
import VideoGridCard from '../VideoGridCard';
import EmptyState from '../EmptyState';

// Componente remontável (keyed pelo pai) que dispara a busca paginada e o scroll
// infinito. A remontagem reseta a acumulação de páginas quando filtros mudam.
export default function VideoResults({
  product,
  categoryId,
  searchQuery,
  uploadDate,
  view,
  isAdminView,
  onEdit,
  onDelete,
}: {
  product: VideoProduct;
  categoryId: number;
  searchQuery: string;
  uploadDate: string | null;
  view: 'list' | 'grid';
  isAdminView: boolean;
  onEdit: (id: number) => void;
  onDelete: (video: VideosGetLast) => void;
}) {
  const { videos, isFetching, listEnded } = useVideoList(
    categoryId,
    searchQuery,
    uploadDate,
    product,
  );

  if (!videos.length) {
    if (isFetching) {
      return (
        <div className="videos-mobile-loading">
          <Spinner />
        </div>
      );
    }
    return <EmptyState isAdminView={isAdminView} />;
  }

  const CardComponent = view === 'grid' ? VideoGridCard : VideoCard;

  return (
    <div className={view === 'grid' ? 'videos-mobile-grid' : 'videos-mobile-list'}>
      {videos.map((video) => (
        <CardComponent
          key={video.id}
          data={video}
          product={product}
          isAdminView={isAdminView}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
      {isFetching && !listEnded && (
        <div className="videos-mobile-loading">
          <Spinner size="sm" />
        </div>
      )}
    </div>
  );
}
